<template>
    <div class="ext-partner-redir" id="ext-partner-redir">
		<template v-if="speedbumpDisplayed">
			<template v-if="partner.id==bookmarkPartner">
				<div class="partner-modal-partner-logo">
					<img :src="partner.thumbnail_url" :alt="partner.name" />
				</div>

				<template v-if="bookmarkStep1">	
					<p>{{ jsLocale['partner_redir_booking_info_1'] }}</p>
					
					<button class="btn btn-primary mb-3" v-on:click="bookmarkGoToStep2()">{{ jsLocale['continue'] }}</button>
					<p><a :href=redirectUrl class="btn btn-link btn-sm" v-on:click="speedbumpAcknowledge($event)">{{ jsLocale['partner_redir_booking_maybe_later'] }}</a></p>
				</template>
				<template v-if="bookmarkStep2">
					<p>{{ jsLocale['partner_redir_booking_link_ready'] }}</p>

					<p>{{ jsLocale['partner_redir_booking_info_2'] }}</p>

					<p>{{ jsLocale['partner_redir_booking_info_3'] }}</p>
					<a :href=redirectUrl class="btn btn-primary" v-on:click="speedbumpAcknowledge($event)">{{ jsLocale['partner_redir_booking_info_button'] }}</a>
				</template>

			</template>
			<template v-else>
				<header>
					<strong>{{ jsLocale['partner_redir_speedbump_title'] }} {{partner.name}}</strong>
				</header>
				<div v-if="!apiError" class="partner-modal-partner-logo">
					<img :src="partner.thumbnail_url" :alt="partner.name" />
				</div>
				<div class="speedbump-items" v-html=speedbumpDescription></div>
				<div class="speedbump-button">
					<a :href=redirectUrl class="btn btn-primary" v-on:click="speedbumpAcknowledge($event)">{{ jsLocale['partner_redir_speedbump_proceed'] }}</a>
				</div>
			</template>
		</template>
		<template v-if="!speedbumpDisplayed">
			<header>
				<strong>
					<span v-if="infoFetched">
						{{ jsLocale['partner_redir_please_wait'] }}
					</span>
					<span v-else-if="apiError === 404">
						{{ jsLocale['partner_redir_partner_unavailable'] }}
					</span>
					<span v-else-if="apiError">
						{{ jsLocale['partner_redir_api_error'] }}
					</span>
					<span v-else>
						{{ jsLocale['partner_redir_registering_donation'] }}
					</span>
				</strong>
			</header>
			<div v-if="!apiError" class="img-area" :class="{'loading': !infoFetched, 'loaded': infoFetched}">
				<template v-if="infoFetched && partner">
					<img class="thumb mb-3" :src="partner.thumbnail_url" :alt="partner.name" />
					<p><strong>{{ partner.name }}</strong></p>
				</template>  
			</div>
			<div v-if="infoFetched" class="redir-info">
				<p>{{ jsLocale['donation'] }}: {{ partner.donation_value_text }}</p>
				<template v-if="(beneficiary && beneficiary.id!=beneficiaryNotSelectedID)">
					<p>{{ jsLocale['header_supported_beneficiary'] }}:<br/>{{ beneficiary.name }}</p>
				</template>
			
				<template v-if="partner.fm_ext_footnote">
					<p class="partner-modal-footnote">{{ partner.fm_ext_footnote }}</p>
				</template>
			</div>

			<div v-if="apiError === 404">
				<p><a href="/shops/" class="btn btn-primary">{{ jsLocale['partner_redir_choose_other_shop'] }}</a></p>
			</div>
			<div v-else-if="apiError">
				<p>{{ jsLocale['partner_redir_reactivate'] }}</p>
				<p>{{ jsLocale['partner_redir_reactivate_info'] }}: <a href="mailto:info@webshopadomany.adjukossze.hu"><strong>webshopadomany.adjukossze.hu</strong></a></p>
			</div>
			<div v-if="!apiError" class="img-area" :class="{'loading': !infoFetched, 'loaded': infoFetched}">
				<div class="loader-animated">
					<img :src="staticUrl+'img/logo/webshopadomany-square.svg'" alt="Loading..." />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	window.clickthrough={
    	partner: null,
    	beneficiary: null
  	};
	import 'whatwg-fetch'
  	import Cookies from 'js-cookie'
  	import queryString from 'query-string'
  	import Vue from 'vue'

  	function getDefaultHeaders () {
    let headers = new Headers()
		headers.append('Accept', 'application/json')
		headers.append('Content-Type', 'application/json')
		headers.append('X-CSRFToken', Cookies.get('csrftoken'))
		return headers
  	}

  export default {
    name: 'ext-redir-page',
    data: function () {
      return {
        apiError: false,
        infoFetched: false,
        infoFetching: true,
        speedbumpDisplayed: false,
        speedbumpItems: [],
        speedbumpDescription: '',
        partner: null,
        beneficiary: null,
        redirectUrl: false,
        redirPage,
        jsLocale,
        user: null,
        staticUrl: window.FM.STATIC_URL || '',
        bookmarkStep1: false,
        bookmarkStep2: false,
        bookmarkButton: (navigator.userAgent.toLowerCase().indexOf('mac') != -1 ? 'CMD' : 'CTRL'),
        bookmarkPartner: window.partnerBookingID, 
        utm_campaign: null,
        beneficiaryNotSelectedID: window.beneficiaryNotSelectedID,
        beneficiarySelect: false
      }
    },
    methods: {
		userCheckBeneficiary: function(){
			let { partner, destination, beneficiary_id, utm_source, utm_medium, utm_campaign, anonymous } = queryString.parse(location.search)
			
			return new Promise((resolve, reject) => {
				resolve(true);
			});
			/*


			return fetch('/api/v2/user-info/', {
				credentials: 'include',
				headers: getDefaultHeaders()
			}).then(response => {
				// Check status and throw error if not 200-ish
				if (response.status >= 200 && response.status < 300) {
					return response;
				} else {
					let error = new Error(response.status + ": " + response.statusText);
					error.response = response;
					throw error;
				}
			})
			.then(response => {
				return response.json()
			})
			.then(data => {
				if(data.beneficiary){
        			if(data.beneficiary.id!=this.beneficiaryNotSelectedID){
						return true;
					} else {
						window.location='/go-to-shop/extension/select-organization/?partner='+partner
						return false;
					}
				} else {
					window.location='/go-to-shop/extension/select-organization/?partner='+partner
					return false;
				}
			})
			.catch(ex => {
				this.infoFetching = false
				this.infoFetched = false
				this.apiError = true
				console.log('fetching or parsing failed', ex)
				throw ex
			})
			*/
		},
      	fetchRedirectInfo: function () {
			// Pick partner and deep link from url and convey them to API
			let { partner, destination, beneficiary_id, utm_source, utm_medium, utm_campaign, anonymous } = queryString.parse(location.search)
			let url = '/api/v2/partner-redirect-info/' + partner + '/'
			let redirReqParams = queryString.stringify({destination, beneficiary_id})
			if (redirReqParams) {
			url = url + '?' + redirReqParams
			}

			if(utm_source){
			Cookies.set('utm_source', utm_source);
			}
			if(utm_medium){
			Cookies.set('utm_medium', utm_medium);
			}

			if(utm_campaign){
			Cookies.set('utm_campaign', utm_campaign);
			this.utm_campaign = utm_campaign;
			}

			this.infoFetching = true
			return fetch(url, {
				credentials: 'include',
				headers: getDefaultHeaders()
			}).then(response => {
				// Check status and throw error if not 200-ish
				if (response.status >= 200 && response.status < 300) {
				return response
				} else {
				let error = new Error(response.status + ": " + response.statusText)
				error.response = response
				throw error
				}
			})
			.then(response => {
				// And if there's no error, then return JSON
				console.log('Will return json')
				return response.json()
			})
			.catch(ex => {
				this.infoFetching = false
				this.infoFetched = false
				this.apiError = true
				console.log('fetching or parsing failed', ex)
				throw ex
			})
      	},
      	redirectToPartner: function (timeout=3000) {
        // wait 2 secs and redirect to shop
        var this2=this;
        this.postClickthroughData();
		
        setTimeout(function () {
          console.log("Redirecting to shop... " + this2.redirectUrl)
          window.location = encodeURI(this2.redirectUrl)
        }, timeout)
      },

      speedbumpAcknowledge: function(event){
        event.preventDefault();
        Cookies.set('partner_'+this.partner.id+'_speedbump', 1, { expires: 7 })
        clickthrough['partner_id']=this.partner.id;
        clickthrough['partner']=this.partner;
        clickthrough['beneficiary']=this.beneficiary;
        clickthrough['user']=this.user;
        this.redirectToPartner(100);
      },

      postClickthroughData: function(){
        try{
          window.postMessage(
            {
              action: "fanimaniExtensionClickthrough",
              data: JSON.parse(JSON.stringify(clickthrough))
            }, "*"
          );
        } catch(e){
          console.log('postClickthroughData() error')
          console.log(e)
        }
      },

      bookmarkGoToStep2: function(event){
        document.body.classList.add('partner-modal-bookmark-step2');
        try{
          let bookmarkUrl = new URL(window.location.href);
          bookmarkUrl.searchParams.set('utm_campaign', 'bookmark');
          history.pushState({}, "", bookmarkUrl);
        } catch (e) {
          console.log('bookmarkGoToStep2() error');
        }
        this.bookmarkStep1 = false;
        this.bookmarkStep2 = true;
      }
    },
    mounted: function () {
		
				this.fetchRedirectInfo()
				.then(data => {
					// FIXME: For some reason this handler gets called also if the promose resulted with an error
					// So exit programatically if there's no data (was error)
					if (typeof(data) === 'undefined') {
						return
					}

					this.partner = data.partner
					this.beneficiary = data.beneficiary
					this.user = data.user

					this.infoFetched = true
					this.infoFetching = false
				
					this.redirectUrl = data.redirect_url


					if(this.partner){
						document.title=this.partner.name+' - Adjukössze Webshopadomány';
					}

					if(data.partner.speedbump_visible){
						var speedbumpCookie=Cookies.get('partner_'+data.partner.id+'_speedbump');
						if(speedbumpCookie || this.utm_campaign=='bookmark' || (redirPage=='mobile' && data.partner.id==this.bookmarkPartner)){
							clickthrough['partner_id']=this.partner.id;
							clickthrough['partner']=this.partner;
							clickthrough['beneficiary']=this.beneficiary;
							clickthrough['user']=this.user;
							this.redirectToPartner();  
						} else {
							if(data.partner.id==this.bookmarkPartner){
								this.bookmarkStep1 = true;
							}
							this.speedbumpDisplayed = true;
							this.speedbumpItems = data.partner.speedbump_description.split(/\r\n|\n|\r/);
							this.speedbumpDescription = data.partner.speedbump_description;
						}
					} else {
						clickthrough['partner_id']=this.partner.id;
						clickthrough['partner']=this.partner;
						clickthrough['beneficiary']=this.beneficiary;
						clickthrough['user']=this.user;
						this.redirectToPartner();  
						
					}
				})
				.catch(error => {
					this.apiError = true
					this.infoFetching = true
					if (error.response && error.response.status) {
						this.apiError = error.response.status
					}
				})
			
		
      	
    }
  }
</script>
